import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { globalNotification } from '../GobalNotification.js';

export const subscribeGlobalNotification = registerSubscription({
  operationName: 'subscribeGlobalNotification',
  resolve: () => () => {
    return globalNotification.pipe();
  },
  type: () => String,
  params: [],
});
